import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { PersonnelSelectorViewModel } from "src/EnterpriseAdministration/personnelManipulation/personnelSelector";
import { SendToLocalNotificationMessage } from "src/server/localNotification";
import { ServerConnection } from "src/server/serverConnection";
import { ISendPackageTab, SendPackageDetailViewModel } from "../sendPackageDetail/sendPackageDetail-viewModel";
import  { CollectingRequestsView } from "./collectingRequests-view"
import { Sorting } from "src/utilities/sorting";

export class CollectingRequestsViewModel extends ViewModel implements ISendPackageTab {
    constructor(parentViewModel: SendPackageDetailViewModel) {
        super(parentViewModel);
        this.tabName = 'درخواست های تجمیع';
        this._typedParent = parentViewModel;
        this.packageCollections = ObservableArray.create<PackageCollection>();
        this.uncollectedPackageItems = ObservableArray.create<CollectionItem>();
        this.personnelSelector = new PersonnelSelectorViewModel(this, false, this._typedParent.fromWarehouseId, false, true, false, false, false);
        this.personnelSelector.refresh();
        this.personnelSelector.onSelectionChanged = q=>{
            this.personnelName = q.title;
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new CollectingRequestsView();
    }
    public getTypeId(): string {
        return "VM-14AD5DB5-CAD9-4219-A1D7-9AF306106555"
    }

    private _typedParent: SendPackageDetailViewModel;

    public set tabName(v: string) { this._tabName = v; } public get tabName(): string { return this._tabName; } private _tabName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set isLoadingUncollected(v: boolean) { this._isLoadingUncollected = v; } public get isLoadingUncollected(): boolean { return this._isLoadingUncollected;} private _isLoadingUncollected: boolean;
    public set packageCollections(v: ObservableArray<PackageCollection>) { this._packageCollection = v; } public get packageCollections(): ObservableArray<PackageCollection> { return this._packageCollection; } private _packageCollection: ObservableArray<PackageCollection>;
    public set uncollectedPackageItems(v: ObservableArray<CollectionItem>) { this._uncollectedPackageItems = v; } public get uncollectedPackageItems(): ObservableArray<CollectionItem> { return this._uncollectedPackageItems;} private _uncollectedPackageItems: ObservableArray<CollectionItem>;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    public set personnelSelector(v: PersonnelSelectorViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSelectorViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSelectorViewModel;    
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set selectAll(v: boolean) { 
        this._selectAll = v; 
        if (v)
            this.uncollectedPackageItems.forEach(x => x.selected = true);
        else
            this.uncollectedPackageItems.forEach(x => x.selected = false);
    }
    public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;
    
    public async load(sendPackageId) {
        this.sendPackageId = sendPackageId;
        this.loadCollection();
        this.loadUncollectedItems();
    }

    public async loadCollection() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/CollectingRequests', {
                SendPackageId: this.sendPackageId
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            this.packageCollections.update(...result.CollectingRequests.map((q, i) => {
                let r = new PackageCollection(this);
                r.totalAmount = 0;
                r.rowNumber = i + 1;
                r.creationTime = moment.utc(q.CollectingTime);
                r.collectionId = q.CollectionId;
                r.collectorId = q.CollectorId;
                r.collectorName = q.CollectorName;
                r.collectionItems.update(...q.CollectionItems.map((p, j) => {
                    let f = new CollectionItem(this);
                    f.rowNumber = j + 1;
                    f.measuredProductId = p.MeasuredProductId;
                    f.productCode = p.ProductCode;
                    f.productName = p.ProductName;
                    f.productCarModel = p.ProductCarModel;
                    f.amount = p.Amount;
                    f.availableBalance = p.AccessibleBalance;
                    f.stockBalance = p.Balance;
                    f.warehouseLocation = p.ProductLocations;
                    r.totalAmount += f.amount;
                    return f;
                }));
                return r;
            }))
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, "خطا")
        } finally {
            this.isLoading = false;
        }
    }

    public async loadUncollectedItems() {
        try {
            this.isLoadingUncollected = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/UncollectedSendPackageItems', {
                SendPackageId: this.sendPackageId
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            this.uncollectedPackageItems.update(...result.SendPackageItems.map((p, i) => {
                let f = new CollectionItem(this);
                    f.rowNumber = i + 1;
                    f.measuredProductId = p.MeasuredProductId;
                    f.productCarModel = p.ProductCarModel;
                    f.productCode = p.ProductCode;
                    f.productName = p.ProductName;
                    f.amount = p.Amount;
                    f.warehouseLocation = p.ProductLocations;
                    return f;
            }))
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, "خطا")
        } finally {
            this.isLoadingUncollected = false;
        }
    }

    getPersonnelId() {
        return this.personnelSelector.selectedItem?.id;
    }
    
    verify():string[]{
        let result :string[] =[];
        if (this.uncollectedPackageItems.filter(q => q.selected).length == 0) {
            result.push('کالایی انتخاب نشده است.')
        }
        if (stringIsNullOrEmpty(this.getPersonnelId())) {
            result.push('جمع آوری کننده مشخص نشده است.')
        }
        return result;
    }

    public async createCollection(makePrint: boolean) {
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان جمع آوری');
                return;
            }
            this.isLoading = true;
            this.isLoadingUncollected = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreatePackageCollection',{
                CollectionItems:this.uncollectedPackageItems.filter(q => q.selected).map(q => {return { 
                    Amount: q.amount,
                    MeasuredProductId: q.measuredProductId
                }}),
                SendPackageId:this.sendPackageId,
                CollectorId:this.getPersonnelId(),
            });
            if (result.IsSuccessful == true) {
                this.load(this.sendPackageId);
                await this.messageBoxConfirmSuccess('جمع آوری با موفقیت انجام شد.','عملیات موفق');
                if (makePrint) {
                    let packageCollection = this.packageCollections.filter(q => q.collectionId == result.CollectionId).at(0);
                    packageCollection.print();
                }
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }
}

export class PackageCollection extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: CollectingRequestsViewModel) {
        super(parent);
        this._typedParent = parent;
        this.collectionItems = ObservableArray.create<CollectionItem>();
    }

    private _typedParent: CollectingRequestsViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set collectorName(v: string) { this._collectorName = v; } public get collectorName(): string { return this._collectorName;} private _collectorName: string;
    public set collectorId(v: string) { this._collectorId = v; } public get collectorId(): string { return this._collectorId;} private _collectorId: string;
    public set totalAmount(v: number) { this._totalAmount = v; } public get totalAmount(): number { return this._totalAmount;} private _totalAmount: number;
    public set collectionId(v: string) { this._collectionId = v; } public get collectionId(): string { return this._collectionId;} private _collectionId: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set collectionItems(v: ObservableArray<CollectionItem>) { this._collectionItems = v; } public get collectionItems(): ObservableArray<CollectionItem> { return this._collectionItems;} private _collectionItems: ObservableArray<CollectionItem>;

    async print() {
        new PrintCollectionReportAction().Print(this);
    }
}

export class CollectionItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set warehouseLocation(v: string) { this._warehouseLocation = v; } public get warehouseLocation(): string { return this._warehouseLocation; } private _warehouseLocation: string;
    public set stockBalance(v: number) { this._stockBalance = v; } public get stockBalance(): number { return this._stockBalance;} private _stockBalance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance;} private _availableBalance: number;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    
}

export class PrintCollectionReportAction{
    public async Print(parent:PackageCollection):Promise<void>{
        return this.PrintFromDto(parent);
    }

    public PrintFromDto(parent:PackageCollection){
        let items = Sorting.stringSort(parent.collectionItems.map(x=>{
            return {
                RowIndex:0,
                Code:x.productCode,
                Description:x.productName,
                Number:x.amount,
                WarehousePlacement:x.warehouseLocation,
                InStockNumber:x.stockBalance,
                AvailableBalance:x.availableBalance,
                // InSendProcess:x.amount,
                // Pnc:x.FinalPrice,
                // Brand:x.FinalPrice,
                // Country:x.FinalPrice,
            };
        }),x=>x.Code);
        items.forEach((x,i)=>{
            x.RowIndex = i+1;
        });
        var message = new SendToLocalNotificationMessage("requestPrint",{
            Form:"CollectionReport",
            Data:{
                CopyCount:1,
                SellerName:'',
                CustomerName:'',
                CollectorName:parent.collectorName,
                CollectionId:parent.collectionId,
                FactorCode:'',
                FactorTime:parent.creationTime,
                SetCollectorTime:parent.creationTime,
                Items:items
            }
        });
        return parent.handleMessage(message);
    }
}
